import React, { ReactElement } from "react";

export function addProps(
  Component: ReactElement | Record<any,any>,
  props: Record<string, any>) {
  const { key, ...rest} = props;
  return Component && <Component.type {...Component.props} {...rest} key={Component.type.isImageType && key ? key : ``} />
}
